import React, { useState, useEffect } from 'react';
import { DataView } from 'primereact/dataview';
import { classNames } from 'primereact/utils';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { setLPDetails, unSet } from '../../slices/createLPSlice';
import { setEdit } from '../../slices/authSlice';
import { LandingPageServe } from '../../services/api/LandingPageServ';
import FooterDialog from '../../components/FooterDialog';
import ManageFooterDialog from '../../components/ManageFooterDialog';
import { FooterServ } from "../../services/api/FooterServ";
import './LpList.css'
import { Link } from 'react-router-dom';
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Chip } from 'primereact/chip';
const LpList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [footerName, setFooterName] = useState("");
  const [footers, setFooters] = useState([]);
 const [showFooterOptions, setShowFooterOptions] = useState(false);
const [showAddFooter, setShowAddFooter] = useState(false);
const [showManageFooter, setShowManageFooter] = useState(false);
const [footerContent, setFooterContent] = useState("");
const toast = useRef(null);
  const [typeDialog, setTypeDialog] = useState(false);
  const [lpList, setLpList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10;
  const [selectedSort, setSelectedSort] = useState({ name: 'Newest First', code: 'createdAt:desc' });
  const [selectedStatus, setSelectedStatus] = useState({ name: 'Published', code: 'published' });
  const [searchKeyword, setSearchKeyword] = useState('');
  // const [modalVisible,setModalVisible]=useState(false)

  const sortList = [
    { name: 'Newest First', code: 'createdAt:desc' },
    { name: 'Oldest First ', code: 'createdAt:asc' }
  ];
  const filterList = [
    { name: 'All', code: 'all' },
    { name: 'Published', code: 'published' },
    { name: 'Pre-Approval', code: 'preapproval' },
    { name: 'Draft', code: 'draft' },
    { name: 'Archived', code: 'archived' },
  ];



  const handleNameClick = (item) => {
    dispatch(setLPDetails(item))
    if (item.lpType === 'external' || item.templateName === 'external') {
      navigate(`/view-external-lp/${item._id}`)
    } else {
      navigate(`/view-lp/${item._id}`)
    }
  }

  const getFooters = async () => {
  try {

    const res = await FooterServ.index();

    setFooters(res.data|| []);

  } catch (error) {
    console.log(error);
  }
};

  const handleItemClick = (item) => {
    console.log('temp' ,item.lpType);
    if (item.lpType === 'external' || item.templateName === 'external') {
      const { domain, path } = item.hostingDetails || {};
      if (domain && item.campaignId) {
        // window.open(`http://${domain}/A${item.campaignId}/index.html`, '_blank');
         navigate(`/view-external-lp/${item._id}`);
      }
      return;
    }
    dispatch(setLPDetails(item))
    dispatch(setEdit(false))
    navigate(`/preview-email/${item._id}/${item.name}`)
  }

  const getLpList = async (obj = {}) => {
    try {
      let params = {
        sort: selectedSort?.code || null,
        status: selectedStatus?.code || null,
        keyword: searchKeyword || null,
        page: currentPage,
        limit: PAGE_SIZE,
      };
      params = { ...params, ...obj };
      const res = await LandingPageServe.index(params);
      const list = Array.isArray(res) ? res : (res.data || []);
      const total = Array.isArray(res) ? res.length : (res.total || 0);
      setLpList(list);
      setTotalRecords(total);
      if (obj.page) setCurrentPage(obj.page);
      dispatch(unSet());
    } catch (error) {
      console.log(error)
    } finally {
    }
  }


  const handleChange = (type, e) => {
    let key, value;
    if (type === 'search') {
      if (e.key === 'Enter') {
        key = 'keyword';
        value = e.target.value;
      } else {
        return;
      }
    }
    if (type === 'status') {
      key = 'status';
      setSelectedStatus(e.value);
      value = e.value.code;
    }
    if (type === 'sort') {
      key = 'sort';
      setSelectedSort(e.value);
      value = e.value.code;
    }
    getLpList({ [key]: value, page: 1 });
  }

  const handlePageChange = (e) => {
    const page = Math.floor(e.first / PAGE_SIZE) + 1;
    getLpList({ page });
  }
const handleSaveEditFooter = async (updatedFooter) => {
  try {

    await FooterServ.update(
      updatedFooter._id,
      updatedFooter
    );

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Footer updated successfully",
      life: 3000,
    });

    getFooters();

  } catch (error) {

    console.log(error);

    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: "Failed to update footer",
      life: 3000,
    });
  }
};




  useEffect(() => {
    getLpList();
     getFooters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSeverity = (lp) => {
    switch (lp.status) {
      case 'published':
        return 'primary';

      case 'draft':
        return 'info';

      case 'archived':
        return 'danger';

      case 'preapproval':
        return 'warning';

      default:
        return 'warning';
    }
  };

  const listItem = (lp, i) => {
    return (
      <>
      <Toast ref={toast} />
        {lp._id &&
              <div className="col-12 md:col-8 md:col-offset-2 p-2" key={i}>
                <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': i !== 0 })}>
                  <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round cursor-pointer" tooltip="view as client" src={lp.thumbnail} alt={lp.name} onClick={(() => handleItemClick(lp))} />
                  <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                    <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                      <div className="text-2xl font-bold text-900 cursor-pointer" onClick={(() => handleNameClick(lp))} tooltip="view" >{lp.name}</div>
                      <div className="text-400 ">{lp.description}</div>
                      <div className="flex align-items-center gap-3">
                        <span className="flex align-items-center gap-2">
                          <i className="pi pi-tag"></i>
                        </span>
                        <Tag value={lp?.pdtId?.name} severity="info"></Tag>
                        <Tag value={lp.client} severity="info"></Tag>
                      </div>
                    </div>
<div className="flex sm:flex-column align-items-center justify-content-end sm:align-items-end gap-3 sm:gap-2">
  <div className="flex flex-wrap align-items-center gap-2" style={{justifyContent: 'end'}}>
    {(Array.isArray(lp.campaignId)
      ? lp.campaignId
      : [lp.campaignId]
    ).map((id) => (
      <Chip
        key={id}
        label={String(id)}
        className="font-semibold"
      />
    ))}
  </div>

  <Button
    size="small"
    className="p-button-rounded"
    severity={getSeverity(lp)}
  >
    {lp.status !== 'preapproval'
      ? lp.status.charAt(0).toUpperCase()
      : 'PA'}
  </Button>
</div>
                  </div>
                </div>
              </div>
        }
      </>);
  };


  const listTemplate = (lpList) => {
    return (
      <div className="grid grid-nogutter">{lpList.map((lp, index) => listItem(lp, index))}</div>
    )
  };

  const header = () => {
    return (
      
      <div className="flex justify-content-between">
        <div>
          <p className='title'>Landing Pages</p>
        </div>
        <div >
          <span className="p-input-icon-left">
            <i className="pi pi-search" style={{ marginLeft: "10px" , marginRight : "10px"}}/>
            <InputText placeholder="Search by Name,Campaign ID and etc...," value={searchKeyword} style={{ width: "400px" , padding : "10px 38px" }} onKeyDown={(e) => handleChange('search', e)} onChange={(e) => { setSearchKeyword(e.target.value) }} />
          </span>
        </div>
        <div className="card flex justify-content-end gap-3">
          <div className="card flex justify-content-center">
            <Dropdown value={selectedStatus} onChange={(e) => { handleChange('status', e) }} options={filterList} optionLabel="name"
              placeholder="Filter By" className="w-full md:w-10rem" style = {{marginTop : 0}}/>
          </div>
          <div className="card flex justify-content-center">
            <Dropdown value={selectedSort} onChange={(e) => { handleChange('sort', e) }} options={sortList} optionLabel="name"
              placeholder="Sort By" className="w-full md:w-10rem" style = {{marginTop : 0}}/>
          </div>
            <div className="card flex justify-content-center">
           <div className="card flex justify-content-center">
  <Button
    label="Manage Footers"
    icon="pi pi-plus"
    className="p-button-primary"
    onClick={() => setShowFooterOptions(true)}
  />
   {/* Popup Dialog */}
 <Dialog
  header="Footer Options"
  visible={showFooterOptions}
  style={{ width: "25rem", borderRadius: "20px" }}
  onHide={() => setShowFooterOptions(false)}
>
  <div className="footer-options-wrapper">
    
    <button
      className="footer-option-btn"
      onClick={() => {
        setShowFooterOptions(false);
        setShowAddFooter(true);
      }}
    >
      <i className="pi pi-plus footer-icon"></i>
      <span>Add Footer</span>
    </button>

    <button
      className="footer-option-btn"
        onClick={async () => {

    await getFooters();

    setShowFooterOptions(false);
    setShowManageFooter(true);
  }}
    >
      <i className="pi pi-pencil footer-icon"></i>
      <span>View / Edit Footer</span>
    </button>

  </div>
</Dialog>

{/* Add Footer Dialog Component */}
<FooterDialog
  visible={showAddFooter}
  onHide={() => setShowAddFooter(false)}
  footerName={footerName}
  setFooterName={setFooterName}
  footerContent={footerContent}
  setFooterContent={setFooterContent}
 
/>

<ManageFooterDialog
  visible={showManageFooter}
  onHide={() => setShowManageFooter(false)}
  footers={footers}
  onSaveEdit={handleSaveEditFooter}
/>
 
</div>
          </div>
          {/* <Button label="Create New" className="p-button-rounded" onClick={() => { setModalVisible(true) }} /> */}

        </div>
      </div>

    );
  };


  return (
    
    <div className="card" style={{ position: 'relative', height: '500px' }}>
      <DataView value={lpList ?? []} listTemplate={listTemplate} header={header()} paginator rows={PAGE_SIZE} totalRecords={totalRecords} first={(currentPage - 1) * PAGE_SIZE} onPage={handlePageChange} lazy />
      {lpList?.length === 0 &&
        <div className="card text-center" style={{ marginTop: "15%" }}>
          <h2 style={{ color: "grey" }}>No records found</h2>
        </div>}
      <div className="fixedButton">
         <Button icon="pi pi-plus" className='shadow-5' rounded severity="info" aria-label="Add new Lp" raised onClick={() => setTypeDialog(true)} />
          {/* <Link to="/create-lp">
          <Button icon="pi pi-plus" className='shadow-5' rounded severity="info" aria-label="Add new Lp" raised />
        </Link>  */}
      </div>
          
       <Dialog header="Select LP Type" visible={typeDialog} onHide={() => setTypeDialog(false)} style={{ width: '360px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', padding: '0.5rem 0' }}>
          <Button
            label="Internal LP"
            icon="pi pi-desktop"
            className="p-button-outlined"
            onClick={() => { setTypeDialog(false); navigate('/create-lp'); }}
          />
          <Button
            label="External LP"
            icon="pi pi-server"
            className="p-button-outlined p-button-success"
            onClick={() => { setTypeDialog(false); navigate('/create-external-lp'); }}
          />
        </div>
      </Dialog>
    </div>

    
  )

}

export default LpList